import { apiGet } from "api/callApi";
import { DropdownWithSearch } from "InnoUI/innoinput";
import { useEffect, useState } from "react";
import AddEditCompany from "views/AdminSettings/Companies/AddEditCompany";

const CompanyDropdown = (props) => {
  const {
    onChange = () => {},
    defaultValue,
    newItemLabel = "",
    name,
    setSelectedCompany = () => {},
    disabledDropdown,
    width,
  } = props;
  const [openModalView, setOpenModalView] = useState(false);
  const [companyData, setCompanyData] = useState([]);

  const getCompanyData = async (successCallback = () => {}) => {
    try {
      const response = await apiGet(`/v1/getcompany`, false);
      setCompanyData(response.data);
      successCallback();
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    getCompanyData();
  }, []);

  const selectOptions =
    companyData
      ?.filter((company) => company.status === 1)
      .map((company) => ({
        id: company.id,
        label: company.companyName,
      })) || [];

  const handleDropdownChange = (value) => {
    const selectedOption = selectOptions.find((option) => option.id === value);
    const selectedLabel = selectedOption ? selectedOption.id : "";
    onChange(name, selectedLabel);
    setSelectedCompany(value);
  };

  const reloadData = (data) => {
    getCompanyData(setSelectedCompany(data.id));
  };

  const onAddNew = () => {
    setOpenModalView(true);
  };

  return (
    <>
      <DropdownWithSearch
        defaultValue={defaultValue}
        placeholder="Select Company"
        options={selectOptions}
        onChange={handleDropdownChange}
        borderColor="#E36E00"
        disabled={false}
        onAddNew={onAddNew}
        newItemLabel={newItemLabel}
        disabledDropdown={disabledDropdown}
        width={width}
      />
      {openModalView && (
        <AddEditCompany
          setOpenModalView={setOpenModalView}
          openModalView={openModalView}
          reloadData={reloadData}
        />
      )}
    </>
  );
};

export default CompanyDropdown;
